import React from "react";

interface LegacyUnsettledModalProps {
  isOpen: boolean;
  orderCount: number;
  settlePrice: number;
  cutoffDate: string;
  onClose: () => void;
  onClickKakao: () => void;
  onClickDetail: () => void;
}

const LegacyUnsettledModal: React.FC<LegacyUnsettledModalProps> = ({
  isOpen,
  orderCount,
  settlePrice,
  cutoffDate,
  onClose,
  onClickKakao,
  onClickDetail,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="mx-4 w-full max-w-sm rounded-2xl bg-white p-6">
        <div className="mb-4 text-center">
          <div className="text-4xl">⚠️</div>
        </div>

        <div className="mb-6 space-y-3 text-center">
          <h2 className="text-xl font-bold text-gray-800">
            이전 거래 미정산 내역이 있어요
          </h2>
          <p className="text-sm text-gray-600">
            {cutoffDate} 이전 거래 중 아직 정산되지 않은 내역은 월 자동 정산에
            포함되지 않습니다.
          </p>
          <div className="rounded-xl border border-amber-200 bg-amber-50 p-3 text-left">
            <p className="text-sm font-medium text-amber-900">
              확인된 미정산 내역
            </p>
            <p className="mt-1 text-sm text-amber-800">
              대상 거래 {orderCount}건
            </p>
            <p className="text-sm text-amber-800">
              예상 정산금 {settlePrice.toLocaleString()}원
            </p>
          </div>
          <p className="text-sm text-gray-600">
            카카오채널로 문의 주시면 확인 후 정산을 도와드릴게요.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <button
            onClick={onClickKakao}
            className="w-full rounded-xl bg-[#FAE100] px-4 py-3 font-semibold text-[#3A1D1D]"
          >
            카카오채널 문의하기
          </button>
          <button
            onClick={onClickDetail}
            className="w-full rounded-xl bg-[#1562fc] px-4 py-3 font-medium text-white"
          >
            자세히 보기
          </button>
          <button
            onClick={onClose}
            className="w-full rounded-xl bg-gray-200 px-4 py-3 font-medium text-gray-700"
          >
            나중에 보기
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegacyUnsettledModal;
